module.exports = __webpack_public_path__ + "media/images/b2b_admin/vector-11f6d08686a64daa0e1ab73868429a14.svg";